import crmChart from '../../assets/images/home/webp/crm-chart.webp'
import crmTable from '../../assets/images/home/webp/crm-table.webp'
import dayAiCharts from '../../assets/images/home/webp/dai-ai-charts.webp'
import intellibit from '../../assets/images/home/webp/intellibit.webp'
import { Arrow } from '../common/Icons'

const CrmVsAi = () => {
  return (
    <div className="flex flex-wrap justify-center md:justify-between">
      <div className="md:w-5/12">
        <h2 className="text-sandstone mb-3 text-center text-[clamp(28px,11.6888vw,36px)] font-semibold text-night-black opacity-60">
          Legacy CRM
        </h2>
        <p className="text-sandstone mb-7 text-center text-lg font-semibold leading-125 tracking-[-0.6px] text-night-black opacity-60 sm:mb-8 sm:text-xl">
          <span className="mb-5 block font-semibold">
            Slows you down by forcing you to think the same way a computer
            thinks.
          </span>
          Like a complex series of tables and fields.
        </p>
        <div className="flex flex-col items-center gap-5">
          <img
            src={crmChart}
            alt="crmChart"
            className="h-full max-h-[330px] w-full max-w-[384px]"
          />
          <span className="rotate-[145deg]">
            <Arrow />
          </span>
          <img
            src={crmTable}
            alt="crmTable"
            className="h-full max-h-[360px] w-full max-w-[553px]"
          />
        </div>
      </div>
      <div className="flex h-full w-1/12 flex-col items-center justify-center">
        <p className="my-3 font-caveat text-[clamp(28px,11.6888vw,54px)] leading-[123%] text-blue sm:-mt-3 md:mb-2">
          Vs
        </p>
        <div className="hidden  h-[780px] w-[1px] bg-[#858585] md:block lg:h-[910px]"></div>
      </div>
      <div className="lg:5/12 md:w-[45%]">
        <h2 className="mb-3 text-center text-[clamp(28px,11.6888vw,36px)] font-semibold text-night-black">
          Day.ai
        </h2>
        <p className="mb-8 text-center text-lg font-semibold leading-125 tracking-[-0.6px] text-night-black sm:text-xl">
          <span className="mb-5 block font-semibold">
            Adapts to you. Your contacts and conversations are automatically
            synced to a new type of CRM.{' '}
          </span>
          Have conversations, let Day.ai do the rest.
        </p>
        <div className="flex flex-col items-center gap-5">
          <img
            src={dayAiCharts}
            alt="dayAiCharts"
            className="h-full max-h-[330px] w-full"
          />
          <span className="rotate-[223deg] -scale-x-100">
            <Arrow />
          </span>
          <img
            src={intellibit}
            alt="intellibit"
            className="h-full max-h-[380px] w-full"
          />
        </div>
      </div>
    </div>
  )
}

export default CrmVsAi
